<template>
  <!-- 折线图 -->
  <div :ref="refId" :datas="datas" style="width: 100%; height: 100%"></div>
</template>

<script>
// refId                 图表id
// datas                 图表数据源
// transverseData        图表的x轴数据源
// colorList             颜色值
// isaverage             是否显示平均值
// innerText             y轴上的单位
// xAxisText             x轴上的单位
// legendList            图例组件的数据源
// gridWidth             图表的宽度
// itemStyleLabel        是否在线上展示数值
// isShowTextColor       是否导出页面时候横轴纵轴显示黑色字
// isoK                  判断折线图是否做单位保留
// isExportTextColor     是否给导出页面时候横轴纵轴显示设置字体25
export default {
  props: [
    "refId",
    "datas",
    "transverseData",
    "colorList",
    "innerText",
    "xAxisText",
    "legendList",
    "gridWidth",
    "itemStyleLabel",
    "isShowTextColor",
    "isExportTextColor",
    "isaverage",
    "isoK",
    "gridY",
    "gridLeft",
    "legendLeft",
  ],
  data() {
    return {
      pieEcharts: "",
      pieOption: {},
    };
  },
  watch: {
    datas: {
      handler(newValue, oldValue) {
        this.setPieOption(
          this.refId,
          newValue,
          this.transverseData,
          this.colorList,
          this.innerText,
          this.xAxisText,
          this.legendList,
          this.gridWidth,
          this.itemStyleLabel,
          this.isShowTextColor,
          this.isExportTextColor,
          this.isaverage,
          this.isoK,
          this.gridY,
          this.gridLeft,
          this.legendLeft
        );
      },
      deep: true,
    },
  },

  beforeDestroy() {
    if (this.pieEcharts) {
      this.pieEcharts.clear();
    }
  },
  mounted() {
    if (this.datas && this.datas.length > 0) {
      this.$nextTick(() => {
        this.setPieOption(
          this.refId,
          this.datas,
          this.transverseData,
          this.colorList,
          this.innerText,
          this.xAxisText,
          this.legendList,
          this.gridWidth,
          this.itemStyleLabel,
          this.isShowTextColor,
          this.isExportTextColor,
          this.isaverage,
          this.isoK,
          this.gridY,
          this.gridLeft,
          this.legendLeft
        );
      });
    }
  },
  methods: {
    isArray(data) {
      // 判断是一条折现图还是多条折线图
      let str1 = 1;
      if (data) {
        for (let i = 0; i < data.length; i++) {
          if (Array.isArray(data[i])) {
            return (str1 = 2);
          }
          return (str1 = 1);
        }
      }
      return str1;
    },

    setPieOption(
      refId,
      datas,
      transverseData,
      colorList,
      innerText,
      xAxisText,
      legendList,
      gridWidth,
      itemStyleLabel,
      isShowTextColor,
      isExportTextColor,
      isaverage,
      isoK,
      gridY,
      gridLeft,
      legendLeft
    ) {
      if (!innerText) {
        innerText = "";
      } else {
        innerText = innerText;
      }
      if (!legendList) {
        legendList = [];
      }
      if (colorList.length <= 0) {
        colorList = ["#fff"];
      }

      let datasList = [];
      let obj = {};

      // let xAxisMin = 0; // x轴最小值
      // let xAxisMax = 0; // x轴最大值
      // let xAxisMinInterval = 0; // x轴最小处的间隔
      // let xAxisMaxInterval = 0; // x轴最大处的间隔
      // let xValues = [];
      // 获取所有x轴data值
      // for (let s of transverseData) {
      //   for (let d of s.transverseData) {
      //     console.log(d);
      //     // if (!xValues.includes(d[0])) {
      //     //   xValues.push(d[0]);
      //     // }
      //   }
      // }

      // xValues.sort((a, b) => a - b); // 按大小对x轴data排序
      // xAxisMinInterval = xValues[1] - xValues[0]; // 最小处的间隔
      // xAxisMaxInterval = xValues[xValues.length - 1] - xValues[xValues.length - 2]; // 最大处的间隔
      // xAxisMin = xValues[0] - xAxisMinInterval; // x轴最小值
      // xAxisMax = xValues[xValues.length - 1] + xAxisMaxInterval; // x轴最大值

      if (this.isArray(datas) == 2) {
        for (let i = 0; i < datas.length; i++) {
          obj = {
            name: legendList[i],
            data: datas[i],
            type: "line",
            markLine: {
              data: isaverage ? [{ type: "average", name: "平均值" }] : null,
            },
            symbolSize: 3, // 设置折点的大小
            showSymbol: false, // 是否开启折点
            smooth: true, // 是否是折线还是曲线
            itemStyle: {
              normal: {
                color: colorList[i],

                // color: this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                //   offset: 0,
                //   color: s[i]
                // },
                // {
                //   offset: 1,
                //   color: '#9E87FF'
                // }
                // ]),
                label: {
                  show: !!itemStyleLabel,
                  position: "top",
                  fontSize: 18,
                  textStyle: {
                    color: isShowTextColor ? "#1d244e" : "#bcc2cf",
                  },
                },
              },
            },
            areaStyle: {
              normal: {
                color: this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(150, 157, 255, 1)",
                    },
                    {
                      offset: 1,
                      color: "rgba(150, 171, 255, .5)",
                    },
                  ],
                  false
                ),
              },
            },
          };
          datasList.push(obj);
        }
      } else {
        obj = {
          name: legendList[0],
          data: datas,
          type: "line",
          markLine: {
            data: isaverage ? [{ type: "average", name: "平均值" }] : null,
          },
          symbolSize: 3, // 设置折点的大小
          showSymbol: false, // 是否开启折点
          smooth: true, // 是否开启曲线模式
          itemStyle: {
            normal: {
              color: colorList[0],
              label: {
                show: !!itemStyleLabel,
                position: "top",
                fontSize: 18,
                textStyle: {
                  color: isShowTextColor ? "#1d244e" : "#bcc2cf",
                },
              },
            },
          },

          areaStyle: {
            normal: {
              color: this.$echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "rgba(150, 157, 255, 1)",
                  },
                  {
                    offset: 1,
                    color: "rgba(150, 171, 255, .5)",
                  },
                ],
                false
              ),
            },
          },
        };
        datasList.push(obj);
      }
      datasList = JSON.stringify(datasList);

      this.pieEcharts = this.$echarts.init(this.$refs[refId]);
      this.pieOption = {
        tooltip: {
          trigger: "axis",
          confine: true, // 浮窗限制在图表内
          backgroundColor: "rgba(0, 0, 0, 0.5)", // 通过设置rgba调节背景颜色与透明度
          borderColor: "rgba(0, 0, 0, 0.1)",
          color: "#fff",
          textStyle: {
            color: "#fff",
          },
          axisPointer: {
            // type: 'shadow',
            label: {
              backgroundColor: "rgba(0,0,0,0.2)",
            },
            borderColor: "rgba(0,0,0,0.2)",
          },
        },
        legend: {
          x: "center",
          left: legendLeft ? legendLeft : "center",
          bottom: "3%",
          textStyle: {
            color: isShowTextColor ? "#1d244e" : "#bcc2cf",
            fontSize:
              isShowTextColor && !isExportTextColor
                ? 16
                : isShowTextColor && isExportTextColor
                ? 25
                : 16,
          },
          data: legendList,
        },
        grid: {
          left: gridLeft ? gridLeft : "2%",
          right: "4%",
          bottom: "15%",
          containLabel: true,
          x: "12%", // x 偏移量
          y: gridY ? gridY : "12%", // y 偏移量
          width: gridWidth ? "94.5%" : "90%", // 宽度
          height: "75%", // 高度
        },
        xAxis: {
          name: xAxisText ? xAxisText : "",
          nameTextStyle: {
            color: "#dde1e5",
            color: isShowTextColor ? "#1d244e" : "#bcc2cf", // 单位
            fontSize:
              isShowTextColor && !isExportTextColor
                ? 16
                : isShowTextColor && isExportTextColor
                ? 25
                : 16,
          },
          boundaryGap: true,
          type: "category",
          data: transverseData,
          axisLine: { show: true }, // 轴线
          axisTick: {
            show: false,
            lineStyle: {
              type: "dotted",
            },
          }, // 刻度
          splitLine: {
            show: false,
            lineStyle: {
              // type: "dashed",  //虚线
              color: "rgba(255,255,255,0.3)",
            },
          }, // 分隔线
          axisLabel: {
            // x轴坐标轴样式
            interval: "auto",
            // rotate: 22,
            textStyle: {
              color: isShowTextColor ? "#1d244e" : "#bcc2cf",
              fontSize:
                isShowTextColor && !isExportTextColor
                  ? 16
                  : isShowTextColor && isExportTextColor
                  ? 25
                  : 13,
            },
          },
        },
        yAxis: {
          name: `${innerText}`,
          nameTextStyle: {
            color: "#dde1e5",
            align: "left",
            color: isShowTextColor ? "1d244e" : "#bcc2cf", // 单位
            fontSize:
              isShowTextColor && !isExportTextColor
                ? 16
                : isShowTextColor && isExportTextColor
                ? 25
                : 16,
          },
          type: "value",
          min: 0,
          minInterval: 1,
          axisLine: { show: true }, // 轴线
          axisTick: {
            show: false,
            lineStyle: {
              type: "dotted",
            },
          }, // 刻度
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed", // 虚线
              color: "rgba(255,255,255,0.3)",
            },
          }, // 分隔线
          axisLabel: {
            // y轴坐标轴样式
            textStyle: {
              color: isShowTextColor ? "#1d244e" : "#bcc2cf",
              fontSize:
                isShowTextColor && !isExportTextColor
                  ? 14
                  : isShowTextColor && isExportTextColor
                  ? 25
                  : 14,
            },
            formatter: isoK
              ? null
              : (params) => {
                  if (params >= 100000000) {
                    return (params / 100000000).toFixed(1) + "亿";
                  } else if ((params >= 10000) & (params < 100000000)) {
                    return (params / 10000).toFixed(1) + "万";
                  } else {
                    return params;
                  }
                },
          },
        },
        symbol: "circle",
        symbolSize: 25,
        series: JSON.parse(datasList),
      };
      // 渲染图表
      this.pieEcharts.setOption(this.pieOption);

      window.addEventListener("resize", () => {
        this.pieEcharts.resize();
      });
    },
  },
};
</script>

<style scoped></style>
